import * as SwitchPrimitive from "@radix-ui/react-switch";
import * as React from "react";

import { cn } from "@/lib/cn";

export const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitive.Root
    ref={ref}
    className={cn(
      "peer relative inline-flex h-4 w-7 shrink-0 cursor-pointer items-center border border-border",
      "bg-muted data-[state=checked]:bg-accent transition-colors",
      "focus-visible:outline focus-visible:outline-1 focus-visible:outline-ring",
      "disabled:cursor-not-allowed disabled:opacity-50",
      className,
    )}
    {...props}
  >
    <SwitchPrimitive.Thumb
      className={cn(
        "pointer-events-none block h-3 w-3 bg-surface translate-x-0",
        "transition-transform data-[state=checked]:translate-x-3",
      )}
    />
  </SwitchPrimitive.Root>
));
Switch.displayName = "Switch";
